<template>
	<section class="is-simple">
		<div>
			<h2>I nostri numeri</h2>
			<div class="flex wrap is-simple-content">
				<div class="col-md-4 col-sm-12">
					<h4>160.000+</h4>
					<div>cene risolte</div>
				</div>
				<div class="col-md-4 col-sm-12">
					<h4>10.000+</h4>
					<div>famiglie abbonate</div>
				</div>
				<div class="col-md-4 col-sm-12">
					<h4>90.000+</h4>
					<div>la nostra community</div>
				</div>
			</div>
		</div>
		<div>
			<div class="flex wrap is-simple-content">
				<div class="col-md-4 col-sm-12">
					<h4>+800%</h4>
					<div>crescita dal 2016</div>
				</div>
				<div class="col-md-4 col-sm-12">
					<h4>€10 mld</h4>
					<div>mercato globale</div>
				</div>
				<div class="col-md-4 col-sm-12">
					<h4>€1,2m</h4>
					<div>capitale raccolto</div>
				</div>
			</div>
		</div>
	</section>

</template>

<script type="text/javascript">
	export default {

	}
</script>

<style scoped>
section {
	text-align: center;
}

h2 {
	text-align: center;
}
h4 {
	font-size: 50px;
    font-weight: 800;
    color: var(--quomi-primary);
}

.is-simple-content {
	padding-top: 25px;
}

.is-simple-img {
	max-height: 50px;
}

.is-simple-img-round {
	max-height: 200px;
}

@media only screen and (max-width: 768px) {
	.is-simple {
		border-bottom: 1px solid #ededed;
	}

	.is-simple-content .col-sm-12 + .col-sm-12{
		padding-top: 30px;
	}
}
</style>